import { FadeUp } from "./FadeUp";

const STEPS = [
  { num: "01", title: "Join FORGE", desc: "Pick your plan and create your profile in seconds." },
  { num: "02", title: "Open FORGE in your dashboard", desc: "No extra login — it's right inside your member dashboard." },
  { num: "03", title: "AI builds your plan", desc: "Diet and workout plan made for you in seconds." },
  { num: "04", title: "Train, share PRs & grow", desc: "Log workouts, share PRs and get monthly reports." },
];

export const HowItWorks = () => (
  <section id="how-it-works" className="py-14 md:py-20 px-6 bg-[#0A0A0B]">
    <div className="max-w-6xl mx-auto">
      <FadeUp>
        <h2 className="font-display text-4xl sm:text-5xl text-white text-center mb-10 md:mb-14">
          4 STEPS TO YOUR PLAN
        </h2>
      </FadeUp>
      <div className="relative grid md:grid-cols-4 gap-10">
        <div className="hidden md:block absolute top-10 left-[12%] right-[12%] h-px bg-[#C6FF3D]/30" />
        {STEPS.map((s, i) => (
          <FadeUp key={s.num} delay={i * 0.12}>
            <div data-testid={`step-card-${s.num}`} className="relative z-10 text-center md:text-left">
              <div className="w-20 h-20 mx-auto md:mx-0 rounded-full bg-[#141416] border border-[#232326] flex items-center justify-center font-display text-2xl text-[#C6FF3D] mb-6">
                {s.num}
              </div>
              <h3 className="text-white text-xl font-semibold mb-2">{s.title}</h3>
              <p className="text-[#A1A1AA] text-sm">{s.desc}</p>
            </div>
          </FadeUp>
        ))}
      </div>
    </div>
  </section>
);
